import { render, staticRenderFns } from "./SideBarItem.vue?vue&type=template&id=d0f0de42&"
import script from "./SideBarItem.vue?vue&type=script&lang=js&"
export * from "./SideBarItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/.jenkins/workspace/platform_beta/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d0f0de42')) {
      api.createRecord('d0f0de42', component.options)
    } else {
      api.reload('d0f0de42', component.options)
    }
    module.hot.accept("./SideBarItem.vue?vue&type=template&id=d0f0de42&", function () {
      api.rerender('d0f0de42', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/components/SideBar/SideBarItem.vue"
export default component.exports